import {Component} from "@angular/core";
import {Page} from "../../../orchestration/page";
import {NavigationService} from "../../../orchestration/navigation.service";
import {NavigationParams} from "../../../orchestration/navigation-params";

@Component({
    selector: "woa-qr-code-page",
    templateUrl: "./qr-code-page.component.html",
    providers: [{provide: Page, useExisting: QrCodePageComponent}]
})
export class QrCodePageComponent extends Page {
    public value: string;
    public displayValue: string;
    public message: string;

    constructor(navigationParams: NavigationParams) {
        super();
        this.value = navigationParams.get("value");
        this.displayValue = navigationParams.get("displayValue") || navigationParams.get("value");
        this.message = navigationParams.get("message");
    }

    public static async showQrCode(navigationService: NavigationService, value: string, message: string, displayValue?: string): Promise<void> {
        return navigationService.createPage("woa-qr-code-page", {
            value: value,
            displayValue: displayValue,
            message: message
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/qr-code/qr-code-page/qr-code-page.component.ts